import Cookies from "js-cookie";
import {CookiesKeysEnum} from "@/lib/enums/CookiesKeysEnum";
import {generateUuid} from "@/lib/utils";

/**
 * The visitor-scoped `anonymous_id` cookie, shared by every analytics vendor.
 *
 * Originally introduced for Customer.io (AC-613) and now also used by Mixpanel
 * (AC-711) as the pre-registration identity and as a super-property. It is
 * forwarded in the registration request so the backend can bind the
 * pre-registration journey to the new player, which is why the value must stay
 * stable across the whole visit — do not regenerate it per session.
 */

const ANONYMOUS_ID_TTL_DAYS = 365;

const anonymousIdCookieConfig = {
    expires: ANONYMOUS_ID_TTL_DAYS,
    sameSite: "lax" as const,
    secure: process.env.NODE_ENV === "production",
};

/**
 * Returns the persisted anonymous id, generating and storing one on first call.
 * Client-side only (relies on cookies + crypto).
 */
export const getAnonymousId = (): string => {
    let id = Cookies.get(CookiesKeysEnum.ANONYMOUS_ID);
    if (!id) {
        id = generateUuid();
        Cookies.set(CookiesKeysEnum.ANONYMOUS_ID, id, anonymousIdCookieConfig);
    }
    return id;
};
